module.exports = __webpack_public_path__ + "img/108.8236e0b3.webp";